/**
 * @fileoverview Opens the Header (mega)'s full-screen search overlay.
 *
 * The live header gets this for free: its opener lives in main.js's PageHeader
 * custom element, which delegates .show-search-link clicks inside <page-header>.
 * The mega header deliberately isn't a <page-header> — that element also wires up
 * the old navigation, sticky behaviour and cart drawer — so it needs its own opener.
 *
 * Everything after opening is the theme's, unchanged: main-search.js runs quick
 * search and the close button, main.js's .page-shade handler closes on an outside
 * click, and main.css's `.section-header .main-search` rules do the styling (hence
 * the `section-header` class on this section).
 */
(() => {
  const header = document.querySelector(".header-mega");
  const search = header?.querySelector(".main-search");
  if (!header || !search) return;

  header.addEventListener("click", (evt) => {
    const link = evt.target.closest(".show-search-link");
    if (!link) return;
    evt.preventDefault();

    // Search and the mobile nav are both full-screen overlays — never stack them.
    // Going through the burger keeps header-mega-mobile.js's scroll lock balanced.
    if (header.classList.contains("header-mega--nav-open")) {
      header.querySelector(".header-mega__burger")?.click();
    }

    document.body.classList.add("show-search");
    // Focus once the overlay's 350ms transition has settled, as the live header does.
    setTimeout(() => search.querySelector(".main-search__input")?.focus(), 500);
  });
})();
